import { useEffect, useRef } from 'react';

export const useMetaDescription = (description: string | undefined) => {
  const getElement = () => document.querySelector<HTMLMetaElement>('meta[name="description"]');
  const prevDescription = useRef<string>(getElement()?.getAttribute('content') ?? '');

  useEffect(() => {
    const previousDescription = prevDescription.current;

    if (description === undefined || description === previousDescription) {
      return;
    }

    const element = getElement();

    element?.setAttribute('content', description);

    return () => {
      element?.setAttribute('content', previousDescription);
    }
  }, [ description ]);
};
